/* icon-wrapper.tsx generated by @compiled/babel-plugin v3.0.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDaaQb%7Bborder-radius%3Avar(--ds-radius-full%2C50%25)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2V7sgO2M4S%7Bborder-width%3Avar(--ds-border-width-selected%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3hxITi6wH8%7Bborder-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VN91d%7Bheight%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0GwItXDIqT%7Balign-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXruoI2d%7Bbackground-color%3Avar(--ds-surface-overlay%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3vBAKHoI2d%7Bborder-color%3Avar(--ds-surface-overlay%2C%23fff)%7D");
import { type FC, type ReactNode } from 'react';
interface IconWrapperProps {
  bgColor?: string;
  children?: ReactNode;
  label?: string;
}
const styles = {
  root: "_0bjKvDaaQb _4bt5LAnQyn _2WAcuGnQyn _2V7sgO2M4S _3hxITi6wH8 _3iDTPbQ4SZ _24h04i2Njc _39xV02N91d _0jFU0VN91d _0hPCNLDIqT _0GwItXDIqT _0KLXruoI2d"
};
const unboundStyles = {
  root: "_3vBAKHoI2d"
};

/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */
const IconWrapper: FC<IconWrapperProps> = ({
  bgColor,
  children
}) => <span role="presentation" style={{
  borderColor: bgColor,
  backgroundColor: bgColor
}} className={ax([styles.root, unboundStyles.root])}>
		{children}
	</span>;
export default IconWrapper;